function parseArray(parameter) {
    if (parameter)
        return Array.isArray(parameter) ? parameter : [parameter];
    return [];
}

function addToArray(oldList = [], newList = []) {
    if (newList.length) {
        return [
            ...oldList || [],
            ...newList || [],
        ];
    }
    return oldList;
}

export function flattenRouteInfo(allRoute) {
    const allRouteData = [];
    const initRouteData = {
        path: '',
        devOnly: false,
        permission: null,
        subscription: null,
        component: null,
        view: undefined,
        sidebarParent: undefined,
    };

    function process(routes, parentRouteData = initRouteData) {
        routes.forEach(route => {
            const {
                path,
                component,
                devOnly,
                children,
                permission,
                subscription,
                integration,
                inhibitorModifiers,
                view,
                id,
                sidebarParentId,
                create,
                permissionCheckMethod,
                subscriptionCheckMethod,
                allowedCountryCodes,
                settingsRequired,
                appsRequired,
            } = route;

            const list = {
                permission: parseArray(permission),
                subscription: parseArray(subscription),
                integration: parseArray(integration),
                inhibitorModifiers: parseArray(inhibitorModifiers),
            };

            const routeData = {
                path: parentRouteData.path + (path && path !== '/' ? (`/${path}`) : ''),
                devOnly: devOnly !== undefined ? devOnly : parentRouteData.devOnly,
                component: component || parentRouteData.component,

                permission: addToArray(parentRouteData.permission, list.permission),
                subscription: addToArray(parentRouteData.subscription, list.subscription),
                integration: addToArray(parentRouteData.integration, list.integration),
                inhibitorModifiers: addToArray(parentRouteData.inhibitorModifiers, list.inhibitorModifiers),

                allowedCountryCodes: allowedCountryCodes || parentRouteData.allowedCountryCodes,
                settingsRequired: settingsRequired || parentRouteData.settingsRequired,
                appsRequired: appsRequired || parentRouteData.appsRequired,

                permissionCheckMethod: permissionCheckMethod || parentRouteData.permissionCheckMethod,
                subscriptionCheckMethod: subscriptionCheckMethod || parentRouteData.subscriptionCheckMethod,
                view,
                create,
                id,
                wrapper: route.wrapper,
                wrapperProps: route.wrapperProps,
                sidebarParentId: sidebarParentId || parentRouteData.sidebarParentId,
            };

            if (routeData.id) {
                if (!routeData.path)
                    routeData.path = '/';

                allRouteData.push(routeData);
            }
            if (children && children.length)
                process(children, routeData);
        });
    }

    process(allRoute);
    return allRouteData;
}
